import { render, staticRenderFns } from "./MainData.vue?vue&type=template&id=306d81d8&scoped=true&"
import script from "./MainData.vue?vue&type=script&lang=js&"
export * from "./MainData.vue?vue&type=script&lang=js&"
import style0 from "./MainData.vue?vue&type=style&index=0&id=306d81d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306d81d8",
  null
  
)

export default component.exports